export default __webpack_public_path__ + "static/media/javascript1.e6df327d.svg";